<template>
  <div class="fixed right-0 bottom-0 left-0 z-30 bg-semantic-base">
    <div class="flex justify-between container mx-auto py-3.5 md:py-4">
      <div class="flex-1 flex justify-start items-center">
        <button
          class="btn-light-outlined"
          :disabled="prev.disabled"
          @click="$emit('click', 'prev')"
        >
          Previous
        </button>

      </div>
      <div class="flex-1 flex justify-center items-center">
      </div>
      <div class="flex-1 flex justify-end items-center">
        <div class="lg:mr-10">
          <slot name="save"></slot>
        </div>
        <button
          v-if="!next.isHidden"
          class="btn-light"
          :disabled="next.disabled"
          @click="$emit('click', 'next')"
        >
          Next
        </button>

        <slot name="export"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'Navigation',

  props: {
    prev: {
      type: Object,
      default: () => ({
        disabled: false
      })
    },
    next: {
      type: Object,
      default: () => ({
        disabled: false,
        isHidden: false
      })
    }
  },

  mounted() {
    this.$store.commit('setNavigation', true)
  },

  computed: {
    ...mapState({
      selectedProduct: state => state?.productSelect?.selectedProduct || {}
    }),
  }
};
</script>

<style scoped>

</style>
